import { jsx as _jsx } from "react/jsx-runtime";
import { AmexLogo } from "./amex-logo";
import { DinersClubLogo } from "./dinersClub-logo";
import { DiscoverLogo } from "./discover-logo";
import { VisaLogo } from "./visa-logo";
import { MasterCardLogo } from "./masterCard-logo";
import { UnionPayLogo } from "./unionPay-logo";
import { JcbLogo } from "./jcb-logo";
import { HiperCardLogo } from "./hiperCard-logo";
import { PlaceholderLogo } from "./placeholder-logo";
export var CardLogoData = [
    { value: _jsx(AmexLogo, {}), label: "amex" },
    { value: _jsx(DinersClubLogo, {}), label: "dinersclub" },
    { value: _jsx(DiscoverLogo, {}), label: "discover" },
    { value: _jsx(VisaLogo, {}), label: "visa" },
    { value: _jsx(MasterCardLogo, {}), label: "mastercard" },
    { value: _jsx(UnionPayLogo, {}), label: "unionpay" },
    { value: _jsx(JcbLogo, {}), label: "jcb" },
    { value: _jsx(HiperCardLogo, {}), label: "hipercard" },
    { value: _jsx(PlaceholderLogo, {}), label: "placeholder" },
];
